import {Injectable} from '@angular/core';
import {StylesService} from '../styles/styles.service';
import {SanitizeXssService} from '../../core/services/santize-xss.service';
import {DiagramTypeConfigService} from '../../core/services/diagram-type-config.service';
import {Q9HtmlEncoderPipe} from '@q9elements/ui-kit/common';

//
@Injectable()
export class ShapesTemplateService {
  constructor(
    private stylesSvc: StylesService,
    private sanitizeXssService: SanitizeXssService,
    private diagramTypeConfigService: DiagramTypeConfigService,
    private encodeHtmlPipe: Q9HtmlEncoderPipe
  ) {}

  private stickerTemplate =
    '<div class="q9-sticker-shape"><div class="paper"><div class="overflow">{{content}}</div></div>{{tags}}</div>';
  private terminatorTemplate = 'X';
  private connectorTemplate = '<div></div>';

  activity(activity) {
    const {template} = this.diagramTypeConfigService.activitySettings();
    const options = {
      content: activity.text,
      number: activity.number
    };

    return this.replaceBindings(template, options);
  }

  text(text) {
    const style = this.stylesSvc.text(text);
    const {template} = this.diagramTypeConfigService.richTextSettings;
    const options = {
      font_style: style.fontCss(),
      content: '<!--contentbegin-->Text<!--contentend-->'
    } as any;

    if (text) {
      const richText = this.sanitizeXssService.sanitizeXssContent(
        this.encodeHtmlPipe.transform(text.text, true)
      );

      options.content = '<!--contentbegin-->' + richText + '<!--contentend-->';
      options.number = text.number;
    }

    return this.replaceBindings(template, options);
  }

  flowline(flowline?) {
    const style = this.stylesSvc.flowline(flowline);
    const settings = this.diagramTypeConfigService.flowlineSettings();

    let content = '<!--contentbegin-->';

    if (flowline && typeof flowline.text === 'string') {
      content += flowline.text;
    } else if (flowline?.text?.value) {
      content += flowline.text.value;
    } else {
      content += settings.config.text;
    }

    content += '<!--contentend-->';

    return this.replaceBindings(settings.template, {
      font_style: style.fontCss(),
      content
    });
  }

  sticker(sticker) {
    const options = {
      content: `<!--contentbegin-->${sticker.text || ''}<!--contentend-->`
    };
    const tagsDiv = document.createElement('div');

    tagsDiv.classList.add('tags-container');
    sticker.tags?.forEach(tag => {
      const tagItem = document.createElement('span');

      tagItem.classList.add('q9-tag-cell');
      tagItem.innerHTML = this.sanitizeXssService.sanitizeXssContent(tag);
      tagsDiv.appendChild(tagItem);
    });
    options['tags'] = tagsDiv.outerHTML;

    return this.replaceBindings(this.stickerTemplate, options);
  }

  terminator() {
    return this.replaceBindings(this.terminatorTemplate);
  }

  connector() {
    return this.replaceBindings(this.connectorTemplate);
  }

  private replaceBindings(template, bindings = {}) {
    Object.keys(bindings).forEach(key => {
      // eslint-disable-next-line no-useless-escape
      template = template.replace(new RegExp('\{\{' + key + '\}\}', 'gm'), bindings[key]);
    });
    template = template.replace(/(\r\n|\n|\r)/gm, '');

    return template;
  }
}
